import { immer } from '../middelware/immer'
import create from 'zustand'
import { devtools } from 'zustand/middleware'

export type BuyStep = 'initialized' | 'minting' | 'claiming' | 'owned'

export type NfdBuyState = {
  initialized: boolean
  minting: boolean
  claiming: boolean
  owned: boolean
  current: BuyStep
}

export type BuyStore = {
  status: {
    [key: string]: NfdBuyState
  }
  initialize: (name: string) => void
  setStatus: (name: string, status: BuyStep) => void
  clearStatus: (name: string) => void
}

export const useBuyStore = create<BuyStore>(
  devtools(
    immer((set) => ({
      status: {},

      initialize: (name: string) => {
        set((state) => {
          state.status[name] = {
            initialized: true,
            minting: false,
            claiming: false,
            owned: false,
            current: 'initialized'
          }
        })
      },

      setStatus: (name: string, status: BuyStep) => {
        set((state) => {
          state.status[name][status] = true
          state.status[name].current = status
        })
      },

      clearStatus: (name: string) => {
        set((state) => {
          delete state.status[name]
        })
      }
    }))
  )
)
